export default __webpack_public_path__ + "static/media/step_F_EN.ba070503.png";